import { useAuthContext } from '../contexts/AuthContext';
import { useLazyQuery, useMutation, useQuery, useSubscription } from '@apollo/client';
import { getAgendaUser } from './queries';

import Spinner from 'react-bootstrap/Spinner';
import Carousel from 'react-bootstrap/Carousel';
import { Button, Card, Col, Container, Row, Image, Modal } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import CustomModal from '../components/Modals/CustomModal';
import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import useHelperService from './services/HelperService';
// import { Helmet, HelmetProvider } from 'react-helmet-async';

function Home() {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  const userId = AuthUserId;
  // I18N
  const { t } = useTranslation();
  // NAVIGATION
  const location = useLocation();
  const navigate = useNavigate();
  // TOAST
  const [showToast, setShowToast] = useState(false);
  const [toastStatus, setToastStatus] = useState("");
  const [toastTitle, setToastTitle] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  // SERVICES
  const {truncate} = useHelperService();

  useEffect(() => {
    if (location.state?.toastMessage) {
      setToastStatus(location.state.status);
      setToastTitle(location.state.title);
      setToastMessage(location.state.toastMessage);
      setShowToast(true);

      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);

  useEffect(() => {
    const scrollOffset = 200;
    const scrollElement = document.querySelector(".js-scroll"); // fading container
    const logoScrollElement = document.querySelector(".slide_logo"); // logo animation

    const elementInView = (el: any, offset = 0) => {
      if (!el) return false;
      const elementTop = el.getBoundingClientRect().top;
      return elementTop <= (window.innerHeight - offset);
    };

    const displayScrollElement = () => scrollElement?.classList.add("scrolled");
    const hideScrollElement = () => scrollElement?.classList.remove("scrolled");
    const handleScrollAnimation = () => {
      if (elementInView(scrollElement, scrollOffset)) {
        displayScrollElement();
      } 
    };

    const displayLogoScrollElement = () => logoScrollElement?.classList.add("scrolled");
    
    const handleLogoAnimation = () => {
      if (elementInView(logoScrollElement, 0)) {
        displayLogoScrollElement();
      }
    };

    const onScroll = () => {
      handleScrollAnimation(); // fading container
      handleLogoAnimation(); // logo animation
    };
    // console.log("logoScrollElement found:", logoScrollElement);

    window.addEventListener("scroll", onScroll);

    // return () => {
    //   window.removeEventListener("scroll", onScroll);
    // };
  const queryString = window.location.search; // Ex: "?missingCompanyLink"
  const query = queryString.substring(1); // Supprime le "?"
  // console.log(query);

  if (query == "missingCompanyLink") {
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t('dashboard.linkedCompanyTitle')}</Modal.Title>
      </Modal.Header>
        
      <Modal.Body>
        <p>{t('dashboard.linkedCompany')}</p>
      </Modal.Body></>);
    // setLinkModal('/');
    setShowCustomModal(true);
  }

  document.title = t('title.home');
}, []);


  // const {data, loading, error, refetch} = useQuery(getAgendaUser, {variables: {userId: userId}});

  // if (loading) {// || loadingShift || loadingRequest) {
  //   return (
  //     <Spinner animation="border" role="status">
  //       <span className="visually-hidden">Loading...</span>
  //     </Spinner>
  //   )
  // };

  
  // const items = [
//     {
//       src: 'https://picsum.photos/id/123/1200/400',
//       altText: 'Slide 1',
//       caption: 'Slide 1',
//       key: 1,
//     },
//     {
//       src: 'https://picsum.photos/id/456/1200/400',
//       altText: 'Slide 2',
//       caption: 'Slide 2',
//       key: 2,
//     },
//     {
//       src: 'https://picsum.photos/id/678/1200/400',
//       altText: 'Slide 3',
//       caption: 'Slide 3',
//       key: 3,
//     },
//   ];

  const goToDetails = (id: string) => {
    window.location.href = `/details${id}`;
    // navigate(`/details${id}`);
  }
  return (
    <>
      <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        // animation={true}
      />
      {/* <HelmetProvider>
        <Helmet>
          <title>{t('home.title')}</title>
          <meta name="description" content={t('meta.description')} />
        </Helmet>
        <div>Contenu principal</div>
      </HelmetProvider> */}
      <div className="blackTop">
        <h1>{t('home.title')}</h1>
        <h2>{t('home.subtitle1')}</h2>
        <h2>{t('home.subtitle2')}</h2>
        <h2>{t('home.subtitle3')}</h2>
      </div>
      <ToastContainer className="p-3 toastTop">
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide className={`${toastStatus}`}>
          { toastTitle != "" &&
            <Toast.Header className={`text-center ${toastStatus}`}>
              <strong className="mx-auto text-white-50  ">{toastTitle}</strong>
            </Toast.Header>
          }
          <Toast.Body className="text-center"><strong className="mx-auto text-white text-center">{toastMessage}</strong></Toast.Body>
        </Toast>
      </ToastContainer>
      <Carousel>
        <Carousel.Item>
          {/* <ExampleCarouselImage text="First slide" /> */}
          <img src="/home/hr_background.png" alt={t('image.team_work')} />
          {/* <img src="hr_background.png" width="1200" height="400"/> */}
          {/* { !(/iPhone|iPod|Android|BlackBerry|IEMobile/i.test(navigator.userAgent)) ? */}
            <Carousel.Caption className="carousel_title">
              <h3>{t('homepage.banner.titleAcheive')}</h3>
              <p>{t('homepage.banner.acheive')}</p>
            </Carousel.Caption>
          {/* } */}
        </Carousel.Item>
        <Carousel.Item>
          {/* <ExampleCarouselImage text="Second slide" /> */}
          <img src="/home/hr_team_work.webp" alt={t('image.hr_team')} />
          {/* { !(/iPhone|iPod|Android|BlackBerry|IEMobile/i.test(navigator.userAgent)) && */}
            <Carousel.Caption className="carousel_title">
              <h3>{t('homepage.banner.titleTeam')}</h3>
              <p>{t('homepage.banner.team')}</p>
            </Carousel.Caption>
          {/* } */}
        </Carousel.Item>
        <Carousel.Item>
          {/* <ExampleCarouselImage text="Third slide" /> */}
          <img src="/home/prod_eff.png" alt={t('image.prod_eff')} />
          {/* { !(/iPhone|iPod|Android|BlackBerry|IEMobile/i.test(navigator.userAgent)) && */}
            <Carousel.Caption className="carousel_title">
              <h3>{t('homepage.banner.titleProd')}</h3>
              <p>{t('homepage.banner.prod')}</p>
            </Carousel.Caption>
          {/* } */}
        </Carousel.Item>
      </Carousel>
      <Container fluid className="banner-container">
        <div style={{position: 'relative', flex: 'none'}} >
          <div className="waveGapTop"></div>
          <div id="wave-container" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" style={{ transform: 'scaleY(-1)' }}>
              <path fill="#b0b3f7" fillOpacity="1" d="M0,160L48,160C96,160,192,160,288,176C384,192,480,224,576,218.7C672,213,768,171,864,133.3C960,96,1056,64,1152,48C1248,32,1344,32,1392,32L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
              </path>
            </svg>
          </div>
        </div>
        {/* <img src="/home/roundedTopBorder200light.png" alt="Banner" className="curved-bottom-image" style={{marginTop: '-1px'}} /> */}
      </Container>
      { (/iPhone|iPod|Android|BlackBerry|IEMobile/i.test(navigator.userAgent)) ?
        <Container className="d-flex justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
          <h2 className="h1 bg_gradient_text" >Schedulum</h2>
        </Container>
      :
        <Container className="d-flex justify-content-center align-items-center" style={{marginTop: '-280px', marginBottom: '220px', position: 'relative'}}>
          <h2 className="h1 bg_gradient_text" >Schedulum</h2>
        </Container>
      }
      
      {/* { !(/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) && */}
      { (/iPhone|iPod|Android|BlackBerry|IEMobile/i.test(navigator.userAgent)) ?
        <Container className="d-flex justify-content-center align-items-center position-relative">
          {/* <ul className="ai_logo slide_logo js-logo-scroll slide-left"> */}
          <ul className="ai_logo slide_logo js-logo-scroll slide-left d-flex flex-wrap justify-content-center">
              {/* <li><img src="/ai_logo/anthropic.png"/></li>
              <li><img src="/ai_logo/Llama.png"/></li>
              <li><img src="/ai_logo/openai.png"/></li>
              <li><img src="/ai_logo/cohere_black.png"/></li>
              <li><img src="/ai_logo/AI21.png"/></li> */}
              <li><img src="/phones/dashboard_mobile.png" className="home_phones" alt={t('image.dashboard_mobile')} /></li>
              <li><img src="/phones/agenda_manager.png" className="home_phones" alt={t('image.agenda_manager')} /></li>
              <li><img src="/phones/sidebar.png" className="home_phones" alt={t('image.sidebar_option')} /></li>
              <li><img src="/phones/gmaps.png" className="home_phones" alt={t('image.gmaps')} /></li>
              <li><img src="/phones/posts.png" className="home_phones" alt={t('image.posts')}/></li>
          </ul>
        </Container>
      :
        <Container className="d-flex justify-content-center align-items-center position-relative">
          {/* <ul className="ai_logo slide_logo js-logo-scroll slide-left"> */}
          <ul className="ai_logo slide_logo js-logo-scroll slide-left d-flex flex-wrap justify-content-center">
              {/* <li><img src="/ai_logo/anthropic.png"/></li>
              <li><img src="/ai_logo/Llama.png"/></li>
              <li><img src="/ai_logo/openai.png"/></li>
              <li><img src="/ai_logo/cohere_black.png"/></li>
              <li><img src="/ai_logo/AI21.png"/></li> */}
              <li><img src="/phones/dashboard_mobile.png" className="home_phones" alt={t('image.dashboard_mobile')} /></li>
              <li><img src="/phones/agenda_manager.png" className="home_phones" alt={t('image.agenda_manager')} /></li>
              <li><img src="/phones/sidebar.png" className="home_phones" alt={t('image.sidebar_option')} /></li>
              <li><img src="/phones/gmaps.png" className="home_phones" alt={t('image.gmaps')} /></li>
              <li><img src="/phones/posts.png" className="home_phones" alt={t('image.posts')} /></li>
          </ul>
        </Container>
      }

      <Container fluid className="card-container" >
        <div style={{position: 'relative', flex: 'none'}} >
          <div id="wave-container">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path fill="#b0b3f7" fillOpacity="1" d="M0,160L48,160C96,160,192,160,288,176C384,192,480,224,576,218.7C672,213,768,171,864,133.3C960,96,1056,64,1152,48C1248,32,1344,32,1392,32L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
              </path>
            </svg>
          </div>
          <div className="waveGapBottom"></div>
        </div>
        {/* <img src="/home/roundedTopBorder200light.png" alt="Banner" className="curved-top-image" style={{marginBottom: '-1px'}}/> */}
        <Container fluid className='w-100 homeCardContainer logo-slider-container pt-5'>
          <div className="logo-slider-wrapper">
            <div className="logo-slider-track">
              {[...Array(2)].map((_, i) => (
                <React.Fragment key={i}>
                  <a href="https://firebase.google.com/" target="_blank" rel="noopener">
                    <img src="/company/Firebase_icon.png" alt="Firebase" style={{height:128, marginRight:10}} loading="lazy"/>
                  </a>
                  <a href="https://aws.amazon.com/" target="_blank" rel="noopener">
                    <img src="/company/aws.svg" alt="AWS" style={{height:128, marginRight:10}} loading="lazy"/>
                  </a>
                  <a href="https://graphql.org/" target="_blank" rel="noopener">
                    <img src="https://graphql.org/img/logo.svg" alt="GraphQL" style={{height:128, marginRight:10}} loading="lazy"/>
                  </a>
                  <a href="https://www.postgresql.org/" target="_blank" rel="noopener">
                    <img src="https://www.postgresql.org/media/img/about/press/elephant.png" alt="PostgreSQL" style={{height:128, marginRight:10}} loading="lazy"/>
                  </a>
                  <a href="https://www.python.org/" target="_blank" rel="noopener">
                    <img src="https://www.python.org/static/opengraph-icon-200x200.png" alt="Python" style={{height:128, marginRight:10}} loading="lazy"/>
                  </a>
                  <a href="https://reactnative.dev/" target="_blank" rel="noopener">
                    <img src="https://reactnative.dev/img/header_logo.svg" alt="React Native" style={{height:128, marginRight:10}} loading="lazy"/>
                  </a>
                  <a href="https://developer.apple.com/swift/" target="_blank" rel="noopener">
                    <img src="https://developer.apple.com/assets/elements/icons/swift/swift-64x64_2x.png" alt="Swift" style={{height:128, marginRight:10}} loading="lazy"/>
                  </a>
                  <a href="https://kotlinlang.org/" target="_blank" rel="noopener">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/7/74/Kotlin_Icon.png" alt="Kotlin" style={{height:128, marginRight:10}} loading="lazy"/>
                  </a>
                  <a href="https://www.ionos.fr" target="_blank" rel="noopener">
                    <img src="/company/ionos.svg" alt="Ionos" style={{height:128, marginRight:10}} loading="lazy"/>
                  </a>
                </React.Fragment>
              ))}
            </div>
          </div>
        </Container>
        <Container fluid className="d-flex justify-content-around flex-wrap homeCardContainer">
          <Container fluid className='w-100 homeCardContainer logo-slider-container mb-4'>
            <Container className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '60px', marginBottom: '20px', position: 'relative'}}>
              <h2 className="h1 bg_gradient_text">{t('home.title')}</h2>
            </Container>
          </Container>

          <Card className="mb-4" style={{ width: '24rem' }}>
            <Card.Img variant="top" src="/home/card_worker.png" />
            {/* <Card.Body className="bg-secondary text-white"> */}
            <Card.Body>
              <Card.Title style={{textAlign: 'center'}}>{t('homepage.card.hr')}</Card.Title>
              <Card.Text>
                {t('homepage.card.hr_content')}
              </Card.Text>
              <Button variant="primary" onClick={() => goToDetails('#rh')}>{t('homepage.card.more_details')}</Button>
            </Card.Body>
          </Card>
          <Card className="mb-4" style={{ width: '24rem' }}>
            <Card.Img variant="top" src="/home/card_tablet_desktop1.png" />
            <Card.Body>
              <Card.Title style={{textAlign: 'center'}}>{t('homepage.card.stat')}</Card.Title>
              <Card.Text>
                {t('homepage.card.stat_content')}
              </Card.Text>
              <Button variant="primary" onClick={() => goToDetails('#time')}>{t('homepage.card.more_details')}</Button>
            </Card.Body>
          </Card>
          <Card className="mb-4" style={{ width: '24rem' }}>
            {/* <Card.Img variant="top" src="/messenger-EN-comp.webp" /> */}
            <Card.Img variant="top" src="/home/card_HoldPhone1.png" />
            <Card.Body>
              <Card.Title style={{textAlign: 'center'}}>{t('homepage.card.communication')}</Card.Title>
              <Card.Text>
                {t('homepage.card.com_content')}
              </Card.Text>
              <Button variant="primary" onClick={() => goToDetails('#communication')}>{t('homepage.card.more_details')}</Button>
            </Card.Body>
          </Card>
        </Container>
        
        <Container fluid className='w-100 homeCardContainer logo-slider-container pb-4'>
          <Container className="d-flex justify-content-center align-items-center homeCardContainer pb-5" style={{position: 'relative'}}>
            <h2 className="bg_gradient_text" >{t('home.discoverDesign')}</h2>
          </Container>
          <div className="logo-slider-wrapper pb-4">
            <div className="logo-slider-track">
              {[...Array(2)].map((_, i) => (
                <React.Fragment key={i}>
                  <img src="/phones/dashboard_mobile.png" className="home_phones" alt={t('image.dashboard_mobile')} loading="lazy"/>
                  <img src="/phones/dashboard_mobile_purple.png" className="home_phones" alt={t('image.dashboard_mobile')} loading="lazy"/>
                  <img src="/phones/dashboard_mobile_green.png" className="home_phones" alt={t('image.dashboard_mobile')} loading="lazy"/>
                  <img src="/phones/agenda_manager.png" className="home_phones" alt={t('image.agenda_manager')} loading="lazy"/>
                  <img src="/phones/agenda_manager_purple.png" className="home_phones" alt={t('image.agenda_manager')} loading="lazy"/>
                  <img src="/phones/agenda_manager_green.png" className="home_phones" alt={t('image.agenda_manager')} loading="lazy"/>
                  <img src="/phones/sidebar.png" className="home_phones" alt={t('image.sidebar_option')} loading="lazy"/>
                  <img src="/phones/sidebar_purple.png" className="home_phones" alt={t('image.sidebar_option')} loading="lazy"/>
                  <img src="/phones/sidebar_green.png" className="home_phones" alt={t('image.sidebar_option')} loading="lazy"/>
                  <img src="/phones/gmaps.png" className="home_phones" alt={t('image.gmaps')} loading="lazy"/>
                  <img src="/phones/gmaps_purple.png" className="home_phones" alt={t('image.gmaps')} loading="lazy"/>
                  <img src="/phones/gmaps_green.png" className="home_phones" alt={t('image.gmaps')} loading="lazy"/>
                  <img src="/phones/posts.png" className="home_phones" alt={t('image.posts')} loading="lazy"/>
                  <img src="/phones/worker.png" className="home_phones" alt={t('image.posts')} loading="lazy"/>
                  <img src="/phones/shift_given.png" className="home_phones" alt={t('image.posts')} loading="lazy"/>
                </React.Fragment>
              ))}
            </div>
          </div>

          <Container fluid className='w-100 homeCardContainer pt-4'>
            <Row className="justify-content-center align-items-center g-3"> {/* g-3 adds some gap */}
              <Col xs="auto">
                <a href="https://apps.apple.com/app/6746083873" target="_blank" rel="noopener">
                  <img src="/company/appleStore_dark.svg"
                      alt={t('image.appStore')}
                      style={{height: 40}} 
                      loading="lazy"/>
                </a>
              </Col>
              <Col xs="auto">
                <a href="https://play.google.com/store/apps/details?id=com.schedulum" target="_blank" rel="noopener">
                  <img src="https://play.google.com/intl/en_us/badges/static/images/badges/fr_badge_web_generic.png"
                      alt={t('image.gplay')}
                      style={{height:60}} 
                      loading="lazy"/>
                </a>
              </Col>
            </Row>
          </Container>

          <Container className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
            <h2 className="bg_gradient_text pb-4">{t('home.subtitle1')}</h2>
            <p className="text-white text-center">{t('home.subtitle1_message1')}</p>
            <p className="text-white text-center">{t('home.subtitle1_message2')}</p>
            <p className="text-white text-center">{t('home.subtitle1_message3')}</p>
            <p className="text-white text-center" style={{fontWeight: 'bold'}}>{t('home.subtitle1_message4')}</p>
            <Link className="free-trial p-3" to="/signup" style={{color: 'white', textDecoration: 'none'}}>
              {t('homepage.try_free')}
            </Link>
          </Container>
          <Container className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
            <h2 className="bg_gradient_text pb-4">{t('home.subtitle2')}</h2>
            <p className="text-white text-center">{t('home.subtitle2_message1')}</p>
            <ul className="text-white pt-4">
              <li><p className="text-white">{t('home.subtitle2_message2')}</p></li>
              <li><p className="text-white">{t('home.subtitle2_message3')}</p></li>
              <li><p className="text-white">{t('home.subtitle2_message4')}</p></li>
              <li><p className="text-white">{t('home.subtitle2_message5')}</p></li>
            </ul>
            <p className="text-white text-center" style={{fontWeight: 'bold'}}>{t('home.subtitle2_message6')}</p>
            <Link className="free-trial p-3" to="/signup" style={{color: 'white', textDecoration: 'none'}}>
              {t('homepage.try_free')}
            </Link>
          </Container>
          <Container className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
            <h2 className="bg_gradient_text pb-4">{t('home.subtitle3')}</h2>
            <p className="text-white text-center">{t('home.subtitle3_message1')}</p>
            <h3 className="text-white text-center">{t('home.subtitle3_message2')}</h3>
            <p className="text-white text-center">{t('home.subtitle3_message3')}</p>
            <ul className="text-white">
              <li><p className="text-white">{t('home.subtitle3_message4')}</p></li>
              <li><p className="text-white">{t('home.subtitle3_message5')}</p></li>
            </ul>
            <h3 className="text-white text-center">{t('home.subtitle3_message6')}</h3>
            <p className="text-white text-center">{t('home.subtitle3_message7')}</p>
            <ul className="text-white pt-4">
              <li><p className="text-white">{t('home.subtitle3_message8')}</p></li>
              <li><p className="text-white">{t('home.subtitle3_message9')}</p></li>
            </ul>
            <p className="text-white text-center">{t('home.subtitle3_message10')}</p>
            <Link className="free-trial p-3" to="/signup" style={{color: 'white', textDecoration: 'none'}}>
              {t('homepage.try_free')}
            </Link>
          </Container>
        </Container>

        {/* { (/iPhone|iPod|Android|BlackBerry|IEMobile/i.test(navigator.userAgent)) ?
          <Container className="d-flex justify-content-center align-items-center position-relative">
            <ul className="ai_logo slide_logo js-logo-scroll slide-left d-flex flex-wrap justify-content-center">
                <li><img src="/phones/dashboard_mobile_green.png" className="home_phones" /></li>
                <li><img src="/phones/agenda_manager_green.png" className="home_phones" /></li>
                <li><img src="/phones/sidebar_green.png" className="home_phones" /></li>
                <li><img src="/phones/gmaps_green.png" className="home_phones" /></li>
                <li><img src="/phones/shift_given.png" className="home_phones" /></li>
            </ul>
          </Container>
        :
          <Container className="d-flex justify-content-center align-items-center position-relative">
            <ul className="ai_logo slide_logo js-logo-scroll slide-left d-flex flex-wrap justify-content-center">
                <li><img src="/phones/dashboard_mobile_green.png" className="home_phones" /></li>
                <li><img src="/phones/agenda_manager_green.png" className="home_phones" /></li>
                <li><img src="/phones/sidebar_green.png" className="home_phones" /></li>
                <li><img src="/phones/gmaps_green.png" className="home_phones" /></li>
                <li><img src="/phones/shift_given.png" className="home_phones" /></li>
            </ul>
          </Container>
        }

        { (/iPhone|iPod|Android|BlackBerry|IEMobile/i.test(navigator.userAgent)) ?
          <Container className="d-flex justify-content-center align-items-center position-relative">
            <ul className="ai_logo slide_logo js-logo-scroll slide-left d-flex flex-wrap justify-content-center">
                <li><img src="/phones/dashboard_mobile_purple.png" className="home_phones" /></li>
                <li><img src="/phones/agenda_manager_purple.png" className="home_phones" /></li>
                <li><img src="/phones/sidebar_purple.png" className="home_phones" /></li>
                <li><img src="/phones/gmaps_purple.png" className="home_phones" /></li>
                <li><img src="/phones/worker.png" className="home_phones" /></li>
            </ul>
          </Container>
        :
          <Container className="d-flex justify-content-center align-items-center position-relative">
            <ul className="ai_logo slide_logo js-logo-scroll slide-left d-flex flex-wrap justify-content-center">
                <li><img src="/phones/dashboard_mobile_purple.png" className="home_phones" /></li>
                <li><img src="/phones/agenda_manager_purple.png" className="home_phones" /></li>
                <li><img src="/phones/sidebar_purple.png" className="home_phones" /></li>
                <li><img src="/phones/gmaps_purple.png" className="home_phones" /></li>
                <li><img src="/phones/worker.png" className="home_phones" /></li>
            </ul>
          </Container>
        } */}

        <Container fluid className="w-100 homeCardContainer">
          <Container className="free-trial-container w-100 mb-5 rounded-3">
            <Container className="justify-content-md-center w-100 mb-4" style={{paddingTop: '15%', textAlign: 'center', justifyContent: 'center', zIndex:100, color: 'white'}}>
              <h4 className="h1 text-center bg_gradient_text_second">
                {t('homepage.start_scheduling')}
                <br/>
                {t('homepage.in_minutes')}
                <i>.</i>
                <br/>
              </h4>
            </Container>
            
            <Container className="justify-content-md-center mt-2 w-100 pb-5" style={{textAlign: 'center', justifyContent: 'center', zIndex:100, color: 'white'}}>
              <h4>
                {/* <Link className="free-trial p-3" to={t('link.create_company')} style={{color: 'white', textDecoration: 'none'}}>
                  {t('homepage.try_free')}
                </Link> */}
                <Link className="free-trial p-3" to="/signup" style={{color: 'white', textDecoration: 'none'}}>
                  {t('homepage.try_free')}
                </Link>
              </h4>
            </Container>
          </Container>
        </Container>
      </Container>
      {/* <Container className="d-flex justify-content-around flex-wrap mb-4 mx-4">
        <Row className="g-4">
          <Col md={4}>
            <Card className="mb-2">
              <Card.Img variant="top" src="/HR-comp.webp" />
              <Card.Body>
                <Card.Title>Human Resources</Card.Title>
                <Card.Text>
                  Centralize your HR. Onboarding employees records, and surveys
                </Card.Text>
                <Button variant="primary">More Details</Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="mb-2">
              <Card.Img variant="top" src="/clockin-EN-comp.webp" />
              <Card.Body>
                <Card.Title>Work Hours</Card.Title>
                <Card.Text>
                  Track your employee work hours. Punch clock, timesheets, and payroll export.
                </Card.Text>
                <Button variant="primary">More Details</Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="mb-2" >
              <Card.Img variant="top" src="/messenger-EN-comp.webp" />
              <Card.Body>
                <Card.Title>Improve communications</Card.Title>
                <Card.Text>
                  Professional chat, internal news feeds, and automatic notifications.
                </Card.Text>
                <Button variant="primary">More Details</Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container> */}
      {/* <div className="clearfix"></div> */}
    </>
   
  );
}

export default Home;